export default "__VITE_ASSET__f0e76136__"